
<div class="discountDetails" :class="{modal}">
  <v-btn v-if="modal" icon class="closeDetails" :aria-label="$vuetify.lang.t('$vuetify.close')" @click="$emit('close')">
    <v-icon>close</v-icon>
  </v-btn>
  <div v-if="expiryDate" class="couponContainer">
    <span class="coupon" aria-hidden="true" v-html="couponSvg"></span>
    <p class="validUntil">{{ $t("COUPON_VALID_UNTIL") }}</p>
    <p class="validUntilDate">{{ formatDate(expiryDate) }}</p>
  </div>
  <div class="steps">
    <h3 class="discountTitle">{{ $t("COUPON_TITLE") }}</h3>
    <div class="coupon" v-for="(coupon, index) in coupons" :key="index">
      <v-divider :class="{secondary: couponActive(coupon)}"/>
      <div v-if="coupon === nextCoupon" class="missingNext">
        <p v-html="$t('COUPON_VALUE_MISSING').replace('{value}', formatPrice((coupon.minimumValue - subtotal)))"></p>
        <v-icon class="rewardPointer secondary--text" size="18" aria-hidden="true">arrow_drop_down</v-icon>
      </div>
      <div class="couponInfo">
        <div :class="{couponDiscount: true, secondary: couponActive(coupon)}">
          <span v-if="coupon.type === couponTypes.VALUE">-{{ formatPriceShort(coupon.discount) }}</span>
          <span v-if="coupon.type === couponTypes.PERCENTAGE">-{{ coupon.discount }}%</span>
          <v-icon v-if="coupon.type === couponTypes.FREESHIPPING" size="30px">local_shipping</v-icon>
        </div>
        <div class="condition">
          <strong v-if="coupon.type === couponTypes.FREESHIPPING" class="shippingReward">{{ $t('COUPON_REWARD_SHIPPING') }}</strong>
          <span v-html="$t('COUPON_CONDITION').replace('{value}', formatPrice(coupon.minimumValue))"></span>
        </div>
      </div>
    </div>
  </div>
</div>
